import Home from './Home';

export default {
    Home,
};


// WEBPACK FOOTER //
// ./src/display/modules/index.ts